import {
  r_maxLength,
  normalizeAll,
  no_spaces,
  r_mobileNumber
} from '../../../utils/validation/restrictions';
import {
  email,
  minLength5,
  passwordValidation,
  required,
  minLength2,
  verifyMobileNumber,
  validateReferralCode,
  requiredradio,
  comparePassword
} from '../../../utils/validation';
import { CORPORATE, INDIVIDUAL } from '../../../utils/constants';
import COLORS from '../../../common/styles/color-pallete';

const TEMPLATE = {
  signup: {
    heading: 'Sign up',
    showForgetPassword: false,
    name: 'SIGN_UP',
    checkbox: true,
    formID: 'auth-form',
    otherOptions: true,
    formStyle: {
      minHeight: '892px'
    },
    radioFields: [
      {
        name: 'account_type',
        type: 'radio',
        value: INDIVIDUAL,
        validate: [requiredradio],
        label: 'Individual'
      },
      {
        name: 'account_type',
        type: 'radio',
        value: CORPORATE,
        validate: [requiredradio],
        label: 'Business'
      }
    ],
    fields: [
      {
        name: 'email',
        type: 'text',
        label: 'Email',
        normalize: r_maxLength(50),
        validate: [email, required, minLength5],
        autoComplete: 'off',
        tooltipDisplay: false
      },
      {
        name: 'password',
        label: 'Password',
        validate: [required, passwordValidation],
        normalize: normalizeAll([no_spaces, r_maxLength(50)]),
        autoComplete: 'off',
        disableCopyPaste: true
      },
      {
        name: 'registered_business_name',
        type: 'text',
        normalize: r_maxLength(50),
        validate: [required, minLength2],
        label: 'Registered business name'
      },
      {
        name: 'country_code',
        type: 'text',
        label: 'Country of registration',
        validate: [required],
        staticValues: [{ key: 1, value: 1, text: 'countries to be shown' }],
        dropdown: true
      },
      {
        name: 'mobile',
        fields: [
          {
            name: 'mobile_country_code',
            type: 'text',
            label: 'Code',
            validate: [required],
            dropdown: true
          },
          {
            name: 'mobile_number',
            type: 'text',
            normalize: normalizeAll([r_mobileNumber, r_maxLength(11)]),
            label: 'Mobile number (optional)',
            validate: verifyMobileNumber
          }
        ]
      },
      {
        name: 'referred_by_referral_code',
        label: 'Referral code (optional)',
        validate: [validateReferralCode],
        normalize: r_maxLength(20),
        autoComplete: 'off',
        type: 'text'
      }
    ]
  },
  forgotPassword: {
    heading: 'Forgot password?',
    buttonHeading: ['Send password reset link', 'Close'],
    formID: 'auth-form',
    name: 'FORGET',
    isReset: true,
    formStyle: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '16px',
      color: COLORS.textGrey,
      minHeight: '512px'
    },
    subHeading: {
      heading: [
        'Please enter the email address you registered with and we will send you a password reset link.',
        // eslint-disable-next-line max-len
        'A reset password  link has been sent to the email address you registered with Instarem. Please check the email and try again if you do not receive the link.'
      ]
    },
    imgStyle: {
      position: 'absolute',
      marginLeft: '-50px'
    },
    fields: [
      {
        name: 'email',
        type: 'text',
        label: 'Email',
        normalize: r_maxLength(50),
        validate: [email, required, minLength5],
        autoComplete: 'off',
        tooltipDisplay: false
      }
    ]
  },
  signin: {
    heading: 'Log in',
    showForgetPassword: true,
    name: 'SIGN_IN',
    checkbox: false,
    formID: 'auth-form',
    otherOptions: true,
    formStyle: {
      minHeight: '680px'
    },
    fields: [
      {
        name: 'email',
        type: 'text',
        label: 'Email',
        normalize: r_maxLength(50),
        validate: [email, required, minLength5],
        autoComplete: 'off',
        tooltipDisplay: false
      },
      {
        name: 'password',
        label: 'Password',
        validate: [required],
        normalize: normalizeAll([no_spaces, r_maxLength(50)]),
        autoComplete: 'off',
        disableCopyPaste: true
      }
    ]
  },
  resetPassword: {
    heading: 'Reset your password',
    showForgetPassword: false,
    checkbox: false,
    formID: 'auth-form',
    otherOptions: false,
    name: 'RESET',
    formStyle: {
      minHeight: '512px'
    },
    fields: [
      {
        name: 'email',
        type: 'text',
        label: 'Email',
        normalize: r_maxLength(50),
        validate: [email, required, minLength5],
        autoComplete: 'off',
        tooltipDisplay: false,
        disabled: true
      },
      {
        name: 'password',
        label: 'Password',
        validate: [required, passwordValidation],
        normalize: normalizeAll([no_spaces, r_maxLength(50)]),
        autoComplete: 'off',
        disableCopyPaste: true
      },
      {
        name: 'confirm_password',
        label: 'Confirm password',
        validate: [required, comparePassword],
        normalize: normalizeAll([no_spaces, r_maxLength(50)]),
        autoComplete: 'off',
        disableCopyPaste: true,
        noRightIcon: true,
        type: 'password'
      }
    ]
  }
};

export default TEMPLATE;
